import React from "react";
import RoutePage from "src/common/components/RoutePage/RoutePage";
import { SettingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

export default () => {
  const profile = useSelector((state) => state.auth.profile);

  const storehouseLinks = {
    prefix: "/storehouse",
    links: [
      {
        link: "/rawmaterials",
        title: "Raw Materials Balance",
        rang: "user",
      },
      {
        link: "/products",
        title: "Products Balance",
        rang: "user",
      },
      {
        link: "/receiptorder/create",
        title: "Add Raw Material/Create Receipt Order",
        rang: "user",
      },
      {
        link: "/receiptorders",
        title: "All Receipt Orders",
        rang: "user",
      },
      {
        link: "/settings",
        title: "Warehouse Settings",
        rang: "user",
        icon: <SettingOutlined />,
        sublinks: [
          {
            link: "/category/create",
            title: "Add Warehouse Category",
            rang: "user",
          },
          {
            link: "/categories",
            title: "All Warehouse Categories",
            rang: "user",
          },
          {
            link: "/instance/create",
            title: "Add Type (Raw Material/Product)",
            rang: "user",
          },
          {
            link: "/instances",
            title: "All Types (Raw Material/Product)",
            rang: "user",
          },
          {
            link: "/initial/raw-materials",
            title: "Enter Initial Raw Materials Stock",
            rang: "user",
          },
          {
            link: "/initial/products",
            title: "Enter Initial Products Stock",
            rang: "user",
          },
          {
            link: "/din-mel/prices",
            title: "Set Prices on din-mel.ru",
            rang: "user",
          },
        ],
      },
    ],
  };

  return <RoutePage values={storehouseLinks} profile={profile} />;
};
